import TodayBadge from '$tablet-app/src/app/components/TodayBadge';
import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import { Button } from '@akin-home/buttons/native';
import { ViewProps } from 'react-native';
import styled from 'styled-components/native';

interface Props extends ViewProps {
  onPressToday?(today: Date): void;
}

export const CalendarScreenModeButtons = ({
  onPressToday,
  ...props
}: Props) => {
  const active_mode = useStateStore((state) => state.calendar.display_mode);
  const setDate = useStateStore((state) => state.calendar.setActiveDate);

  const setDisplayMode = useStateStore(
    (state) => state.calendar.setDisplayMode
  );

  const onPressWeek = () => setDisplayMode('week');

  const onPressMonth = () => setDisplayMode('month');

  const handleTodayPress = () => {
    const today = new Date();
    onPressToday?.(new Date()) || setDate(today.toISOString());
  };

  return (
    <Row {...props}>
      <Button
        variant={active_mode === 'week' ? 'primary' : 'secondary'}
        onPress={onPressWeek}
      >
        Week
      </Button>
      <Button
        variant={active_mode === 'month' ? 'primary' : 'secondary'}
        onPress={onPressMonth}
      >
        Month
      </Button>

      <Today onPress={handleTodayPress} />
    </Row>
  );
};

const Row = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

const Today = styled(TodayBadge)`
  margin-left: 16px;
`;
